<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>
<div class="row" *ngIf="loaded">
  <div class="col-10"><small class=" text-center align-self-center"><i class="text-danger">* indicates mandatory field</i></small></div>
  <div class="col-10">
    <dl class="row">
      <dt class="col-sm-5 text-right align-self-center">* Title :</dt>
      <dd class="col-sm-5">
          <input type="text" [(ngModel)]="episodeData.title" class="form-control" />
      </dd>
      <dt class="col-sm-5 text-right align-self-center">* Content :</dt>
      <dd class="col-sm-5">
          <input type="text" [(ngModel)]="episodeData.content" class="form-control" />
      </dd>
      <dt class="col-sm-5 text-right align-self-center"> Description :</dt>
      <dd class="col-sm-5">
          <input type="text" [(ngModel)]="episodeData.description" class="form-control" />
      </dd>
    </dl>
  </div>
</div>
<div class="row mb-3" *ngIf="loaded">
  <div class="col-10 text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
